<template>
    <div class="sidebar sidebar-dark">
        <div class="sidebar-header p-2 text-center" >
            <img src="../../src/assets/logo.png" alt="digiTRACK"
                class="brand-image img-circle1 elevation-3 me-2 mb-1" style=" width:40px;" />
            <div><router-link to="/dashboard" class="sidebar-logo">digiTRACK</router-link></div>
        </div>
        <div id="sidebarMenu" class="sidebar-body">
            <div class="nav-group show">
                <ul class="nav nav-sidebar">
                    <li class="nav-item">
                        <router-link to="/dashboard" :style="{ color: dashboardActive }" @click="showTab('Dashboard')"
                            class="nav-link"><i class="ri-command-line"></i> <span>Dashboard</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group" :class="{ show: showLinage }" @click="showTab('LineageParameters')"
                v-if="permission('LineageParameters')">
                <a href="javascript:void(0)" :style="{ color: color }" class="nav-label"><i
                        class="ri-equalizer-line icn"></i> Lineage parameters</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'clusters.view'">
                        <router-link to="/clusters" v-bind:class="{ active: $route.path === '/clusters' }"
                            class="nav-link"><i class="ri-command-line"></i> <span>Clusters</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'plants.view'">
                        <router-link to="/plants" v-bind:class="{ active: $route.path === '/plants' }"
                            class="nav-link"><i class="ri-building-fill"></i> <span>Plants</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'sections.view'">
                        <router-link to="/section" v-bind:class="{ active: $route.path === '/section' }"
                            class="nav-link"><i class="ri-stack-line"></i> <span>Section</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'frequencies.view'">
                        <router-link to="/frequency" v-bind:class="{ active: $route.path === '/frequency' }"
                            class="nav-link"><i class="ri-rfid-line"></i> <span>Frequency</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'departments.view'">
                        <router-link to="/department" v-bind:class="{ active: $route.path === '/department' }"
                            class="nav-link"><i class="ri-government-line"></i> <span>Department</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group" :class="{ show: showType }" @click="showTab('TypeParameters')"
                v-if="permission('TypeParameters')">
                <a href="javascript:void(0)" :style="{ color: typeParameterColor }" class="nav-label"><i
                        class="ri-corner-up-right-double-line icn"></i> Type Parameters</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'equipment_types.view'">
                        <router-link to="/equipment_types" v-bind:class="{ active: $route.path === '/equipment_types' }"
                            class="nav-link"><i class="ri-equalizer-line"></i> <span>Equipment Type</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'asset_types.view'">
                        <router-link to="/asset_types" v-bind:class="{ active: $route.path === '/asset_types' }"
                            class="nav-link"><i class="ri-building-3-line"></i> <span>Asset Type</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'service_types.view'">
                        <router-link to="/service_types" v-bind:class="{ active: $route.path === '/service_types' }"
                            class="nav-link"><i class="ri-layout-fill"></i> <span>Service Type</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'spare_types.view'">
                        <router-link to="/spare_types" v-bind:class="{ active: $route.path === '/spare_types' }"
                            class="nav-link"><i class="ri-shapes-line"></i> <span>Spare Types</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'reasons.view'">
                        <router-link to="/reasons" v-bind:class="{ active: $route.path === '/reasons' }"
                            class="nav-link"><i class="ri-color-filter-line"></i> <span>Reasons</span></router-link>
                    </li>
                </ul>
            </div>

            <div class="nav-group show">
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'assetParameters.view'">
                        <router-link to="/asset_parameters" :style="{ color: AssetParametersColor }"
                            @click="showTab('AssetParameters')" class="nav-link"><i class="ri-stack-fill"></i>
                            <span>Asset Parameters</span></router-link>
                    </li>
                </ul>
            </div>

            <div class="nav-group" v-if="permission('ListParameters')" :class="{ show: showList }"
                @click="showTab('ListParameters')">
                <a href="javascript:void(0)" :style="{ color: listParameterColor }" class="nav-label"><i
                        class="ri-list-settings-line icn"></i> List parameters</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'checks.view'">
                        <router-link to="/checks" v-bind:class="{ active: $route.path === '/checks' }"
                            class="nav-link"><i class="ri-command-line"></i> <span>Checks</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'spares.view'">
                        <router-link to="/spares" v-bind:class="{ active: $route.path === '/spares' }"
                            class="nav-link"><i class="ri-align-left"></i> <span>Spares</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'services.view'">
                        <router-link to="/services" v-bind:class="{ active: $route.path === '/services' }"
                            class="nav-link"><i class="ri-drag-move-2-line"></i> <span>Services</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group" v-if="permission('Masters')" :class="{ show: showMaster }"
                @click="showTab('Masters')">
                <a href="javascript:void(0)" :style="{ color: masterColor }" class="nav-label"><i
                        class="ri-settings-5-line icn"></i> Masters</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'equipment.view'">
                        <router-link to="/equipment" v-bind:class="{ active: $route.path === '/equipment' }"
                            class="nav-link"><img src="assets/images/machine.png" class="me-2" style="width: 22px;"
                                alt=""><span>Equipment</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'asset_templates.view'">
                        <router-link to="/asset_templates"
                            v-bind:class="{ active: $route.path === '/asset_templates' || $route.path === '/asset/create' || $route.name === 'Assets.Edit' || $route.name === 'Assets.View' }"
                            class="nav-link"><i class="ri-briefcase-fill"></i><span>Asset Template</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'assets.view'">
                        <router-link to="/assets"
                            v-bind:class="{ active: $route.path === '/assets' || $route.path === '/asset/create' || $route.name === 'Assets.Edit' || $route.name === 'Assets.View' }"
                            class="nav-link"><i class="ri-briefcase-fill"></i><span>Asset</span></router-link>
                    </li>
                </ul>
            </div>
            <!-- <div class="nav-group" v-if="permission('Registers')" :class="{show:showRegister}" @click="showTab('Registers')"> -->
            <div class="nav-group" v-if="permission('Registers')" :class="{ show: showRegister }">
                <a href="javascript:void(0)" :style="{ color: registerColor }" class="nav-label" @click.stop.prevent="toggleRegisterMenu"><i
                        class="ri-links-fill icn"></i> Registers</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'activity_registers.view'">
                        <router-link
                            v-bind:class="{ active: $route.path === '/activities' || $route.name === 'Activity.Create' || $route.name === 'Activity.Edit' }"
                            to="/activities" class="nav-link" @click.stop><i class="ri-list-check"></i><span>Activity
                                Register</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'service_registers.view'">
                        <router-link
                            v-bind:class="{ active: $route.path === '/user_services' || $route.name === 'UserServices.Create' || $route.name === 'UserServices.Edit' }"
                            to="/user_services" class="nav-link" @click.stop><i class="ri-flow-chart"></i><span>Service
                                Register</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'check_registers.view'">
                        <router-link
                            v-bind:class="{ active: $route.path === '/user_checks' || $route.name === 'UserChecks.Create' || $route.path === 'UserChecks.Edit' }"
                            to="/user_checks" class="nav-link" @click.stop><i class="ri-survey-line"></i><span>Check
                                Register</span></router-link>
                    </li>

                    <li class="nav-item" v-can="'inward_spare_register.view'">
                        <router-link
                            v-bind:class="{ active: $route.path === '/inward_spares' || $route.name === 'InwardSpares.Create' || $route.path === 'InwardSpares.Edit' }"
                            to="/inward_spares" class="nav-link" @click.stop><i class="ri-archive-line"></i><span>Inward Spare
                                Register</span></router-link>
                    </li>
                    <!-- <li class="nav-item" v-can="'assets.view'">
                        <router-link to="/assets" class="nav-link"><i class="ri-briefcase-fill"></i><span>Asset</span></router-link>
                    </li>          -->
                </ul>
            </div>

            <!-- <div class="nav-group">
                <a href="javascript:void(0)" class="nav-label"><i class="ri-flow-chart icn"></i> Services Register</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item">
                        <router-link to="/user_services" class="nav-link"><i class="ri-contacts-line"></i><span>User Services</span></router-link>
                    </li>
                </ul>
            </div>  -->
            <div class="nav-group" v-if="permission('UserManagement')" :class="{ show: showUser }"
                @click="showTab('UserManagement')">
                <a href="javascript:void(0)" :style="{ color: userManagementColor }" class="nav-label"><i
                        class="ri-user-settings-line icn"></i> User Management</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'roles.view'">
                        <router-link to="/role" v-bind:class="{ active: $route.path === '/role' }" class="nav-link"><i
                                class="ri-database-2-fill"></i> <span>Roles</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'users.view'">
                        <router-link to="/users"
                            v-bind:class="{ active: $route.path === '/users' || $route.name === 'Users.Create' || $route.path === 'Users.Edit' }"
                            class="nav-link"><i class="ri-user-line"></i> <span>Users</span></router-link>
                    </li>
                    <li class="nav-item" v-can="'permissions.view'">
                        <router-link to="/permissions" v-bind:class="{ active: $route.path === '/permissions' }"
                            class="nav-link"><i class="ri-sensor-fill"></i> <span>Permissions</span></router-link>
                    </li>
                </ul>
            </div>

            <div class="nav-group" v-if="permission('Reports')" :class="{ show: showReports }">
                <a href="javascript:void(0)" style="color: inherit;" class="nav-label" @click.stop.prevent="toggleReports">
                    <i class="ri-file-chart-line icn"></i>&nbsp; Reports
                </a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'asset_report'">
                        <router-link to="/asset_reports" class="nav-link" @click.stop>
                            <i class="ri-file-chart-2-line"></i> <span>Asset Report</span>
                        </router-link>
                    </li>
                    <li class="nav-item" v-can="'job_pending_report'">
                        <router-link to="/pending_jobs" class="nav-link" @click.stop>
                            <i class="ri-pass-pending-line"></i> <span>Job Pending Report</span>
                        </router-link>
                    </li>
                    <li class="nav-item" v-can="'deviation_report'">
                        <router-link to="/deviation_reports" class="nav-link" @click.stop>
                            <i class="ri-store-3-fill"></i> <span>Deviation Report</span>
                        </router-link>
                    </li>
                    <li class="nav-item" v-can="'breakdown_report'">
                        <span class="nav-link">
                            <i class="ri-file-chart-2-line"></i> <span>BreakDown Report</span>
                        </span>
                    </li>
                    <li class="nav-item" v-can="'inventory_report'">
                       <router-link to="/inventory_report" class="nav-link" @click.stop>
                            <i class="ri-store-3-fill"></i> <span>Inventory Report</span>
                        </router-link>
                    </li>
                    <li class="nav-item" v-can="'spare_ledger_report'">
                       <router-link to="/spare_ledger_report" class="nav-link" @click.stop>
                            <i class="ri-store-3-fill"></i> <span>Spare Ledger Report</span>
                        </router-link>
                    </li>
                </ul>
            </div>

            <div class="nav-group show">
                <ul class="nav nav-sidebar">
                    <li class="nav-item" v-can="'downloaded_reports.view'">
                        <router-link to="/downloaded_reports" :style="{ color: DownloadedReportsColor }"
                            @click="showTab('DownloadedReports')" class="nav-link"><i class="ri-download-line"></i>
                            <span>Downloaded Reports</span></router-link>
                    </li>
                </ul>
            </div>

            <!-- <div class="nav-group">
                <a href="javascript:void(0)" :style="{color:reportsColor}" class="nav-label"><i class="ri-file-copy-2-line icn"></i> Reports</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item">
                        <router-link to="" class="nav-link"><img src="assets/images/generator.png" style="width: 20px;" class="me-2" alt=""><span>Assets Report</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="" class="nav-link"><img src="assets/images/machine.png" class="me-2" style="width: 22px;" alt=""><span>Equipment Report</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="" class="nav-link"><i class="ri-tools-line"></i><span>Spares Report</span></router-link>
                    </li>
                </ul>
            </div> -->
        </div>
        <!-- <div class="sidebar-footer">
            <div class="sidebar-footer-top">
                <div class="sidebar-footer-thumb">
                    <div class="avatar online" v-if="$store.getters.user?.avatar"><img :src="$store.getters.user?.avatar" alt="" /></div>
                <div class="avatar online" v-else><img src="../../public/assets/images/default_avatar.png" alt="" /></div>
                </div>

                <div class="sidebar-footer-body">
                    <h6>{{$store.getters?.user?.name}}</h6>
                    <p>{{ $store.getters.user.role?.role }}</p>
                </div>
                <a id="sidebarFooterMenu" href="#" class="dropdown-link"><i class="ri-arrow-down-s-line"></i></a>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            permissions: this.$store.getters.permissions,
            dashboardActive: 'white !important',
            color: 'rgba(255, 255, 255, .6) !important',
            typeParameterColor: 'rgba(255, 255, 255, .6) !important',
            motorParameterColor: 'rgba(255, 255, 255, .6) !important',
            listParameterColor: 'rgba(255, 255, 255, .6) !important',
            masterColor: 'rgba(255, 255, 255, .6) !important',
            registerColor: 'rgba(255, 255, 255, .6) !important',
            userManagementColor: 'rgba(255, 255, 255, .6) !important',
            reportsColor: 'rgba(255, 255, 255, .6) !important',
            AssetParametersColor: 'rgba(255, 255, 255, .6) !important',
            DownloadedReportsColor: 'rgba(255, 255, 255, .6) !important',
            showLinage: false,
            showType: false,
            showMotor: false,
            showList: false,
            showMaster: false,
            showRegister: false,
            showUser: false,
            AssetParametersActive: false,
            DownloadedReportsActive: false,
            showReports: false
        };
    },
    mounted() {
        this.syncRegistersMenuFromRoute(this.$route);
        this.syncReportsMenuFromRoute(this.$route);
    },
    watch: {
        $route(to) {
            this.syncRegistersMenuFromRoute(to);
            this.syncReportsMenuFromRoute(to);
            this.showTab(to.path, to.name);
        },
    },
    methods: {
        syncRegistersMenuFromRoute(route) {
            if (!this.permission("Registers")) {
                return;
            }
            const p = route.path;
            const n = route.name;
            const registerRouteNames = new Set([
                "Activities.Index",
                "Activity.Create",
                "Activity.Edit",
                "UserServices.Index",
                "UserServices.Create",
                "UserServices.Edit",
                "UserChecks.Index",
                "UserChecks.Create",
                "UserChecks.Edit",
                "UserChecks.View",
                "InwardSpares.Index",
                "InwardSpares.Create",
                "InwardSpares.Edit",
            ]);
            const onRegister =
                registerRouteNames.has(n) ||
                p.startsWith("/activities") ||
                p.startsWith("/activity/") ||
                p.startsWith("/user_services") ||
                p.startsWith("/user_service/") ||
                p.startsWith("/user_checks") ||
                p.startsWith("/user_check/") ||
                p.startsWith("/inward_spares");
            this.showRegister = onRegister;
        },
        toggleRegisterMenu() {
            if (this.showRegister) {
                this.showRegister = false;
                return;
            }
            requestAnimationFrame(() => {
                this.showRegister = true;
            });
        },
        syncReportsMenuFromRoute(route) {
            if (!this.permission("Reports")) {
                return;
            }
            const p = route.path;
            const onReport =
                p.startsWith("/asset_reports") ||
                p === "/pending_jobs" ||
                p === "/deviation_reports" ||
                p === "/inventory_report" ||
                p === "/spare_ledger_report";
            this.showReports = onReport;
        },
        toggleReports() {
            if (this.showReports) {
                this.showReports = false;
                return;
            }
            requestAnimationFrame(() => {
                this.showReports = true;
            });
        },
        logout() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "logout", data: vm.$store.getters.user })
                .then(function () {
                    loader.hide();
                    vm.$store.dispatch("logout");
                    vm.$router.push("/");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        showTab(tab, name) {
            this.dashboardActive = 'rgba(255, 255, 255, .6) !important'
            this.color = 'rgba(255, 255, 255, .6) !important'
            this.typeParameterColor = 'rgba(255, 255, 255, .6) !important'
            this.motorParameterColor = 'rgba(255, 255, 255, .6) !important'
            this.listParameterColor = 'rgba(255, 255, 255, .6) !important'
            this.masterColor = 'rgba(255, 255, 255, .6) !important'
            this.registerColor = 'rgba(255, 255, 255, .6) !important'
            this.userManagementColor = 'rgba(255, 255, 255, .6) !important'
            this.reportsColor = 'rgba(255, 255, 255, .6) !important'
            this.AssetParametersColor = 'rgba(255, 255, 255, .6) !important'
            this.DownloadedReportsColor = 'rgba(255, 255, 255, .6) !important'


            if (tab == '/clusters' || tab == '/plants' || tab == '/section' || tab == '/frequency' || tab == '/department') {
                this.color = 'white !important';
                this.showLinage = !this.showLinage;
            } else if (tab == '/equipment_types' || tab == '/asset_types' || tab == '/service_types' || tab == '/spare_types' || tab == '/reasons') {
                this.typeParameterColor = 'white !important';
                this.showType = !this.showType;
            } else if (tab == '/voltages' || tab == '/watt_rating' || tab == '/frame' || tab == '/mounting' || tab == '/make' || tab == '/speed') {
                this.motorParameterColor = 'white !important';
                this.showMotor = !this.showMotor;
            }
            else if (tab == '/asset_parameters') {
                this.AssetParametersColor = 'white !important';
                this.AssetParametersActive = !this.AssetParametersActive
            } else if (tab == '/checks' || tab == '/spares' || tab == '/services') {
                this.listParameterColor = 'white !important';
                this.showList = !this.showList;
            } else if (tab == '/equipment' || tab == '/assets' || name == 'Assets.Create' || name == 'Assets.Edit' || name == 'Assets.View' || name == '/assets_templates') {
                this.masterColor = 'white !important';
                this.showMaster = !this.showMaster;
            } else if (
                tab === "/activities" ||
                name === "Activity.Create" ||
                name === "Activity.Edit" ||
                tab.startsWith("/activity/") ||
                tab === "/user_services" ||
                name === "UserServices.Create" ||
                name === "UserServices.Edit" ||
                tab.startsWith("/user_service/") ||
                tab === "/user_checks" ||
                name === "UserChecks.Create" ||
                name === "UserChecks.Edit" ||
                name === "UserChecks.View" ||
                tab.startsWith("/user_check/") ||
                tab.startsWith("/inward_spares")
            ) {
                this.registerColor = "white !important";
            } else if (tab == '/role' || tab == '/users' || name == 'Users.Create' || name == 'Users.Edit' || tab == '/permissions') {
                this.userManagementColor = 'white !important';
                this.showUser = !this.showUser;
            } else if (tab == '/dashboard') {
                this.dashboardActive = 'white !important';
            }
            else if (tab == '/downloaded_reports') {
                this.DownloadedReportsColor = 'white !important';
                this.DownloadedReportsActive = !this.DownloadedReportsActive
            }

            switch (tab) {
                case "Dashboard":
                    this.dashboardActive = 'white !important';
                    break;
                case "LineageParameters":
                    this.color = 'white !important';
                    this.showLinage = !this.showLinage;
                    break;
                case "TypeParameters":
                    this.typeParameterColor = 'white !important';
                    this.showType = !this.showType;
                    this.showLinage = false
                    break;
                case "MotorParameters":
                    this.motorParameterColor = 'white !important';
                    this.showMotor = !this.showMotor;
                    break;
                case "ListParameters":
                    this.listParameterColor = 'white !important';
                    this.showList = !this.showList;
                    break;
                case "Masters":
                    this.masterColor = 'white !important';
                    this.showMaster = !this.showMaster;
                    break;
                case "UserManagement":
                    this.userManagementColor = 'white !important';
                    this.showUser = !this.showUser;
                    break;
                default:
                    break;
            }
        },
        permission(ability) {
            let permissions = this.$store.getters.permissions;
            if (permissions && permissions.length != 0) {
                let permission = [];
                if (ability == "LineageParameters") {

                    permission = permissions.filter(function (el) {
                        return (
                            el.ability.ability == "clusters.view" ||
                            el.ability.ability == "plants.view" ||
                            el.ability.ability == "sections.view" ||
                            el.ability.ability == "frequencies.view" ||
                            el.ability.ability == "departments.view"
                        );
                    });
                }
                else if (ability == "TypeParameters") {
                    permission = permissions.filter(function (el) {
                        return el.ability.ability == "equipment_types.view" ||
                            el.ability.ability == "asset_types.view" ||
                            el.ability.ability == "service_types.view" ||
                            el.ability.ability == "spare_types.view" ||
                            el.ability.ability == "reasons.view"
                    });
                }
                if (ability == "ListParameters") {
                    permission = permissions.filter(function (el) {
                        return el.ability.ability == "checks.view" ||
                            el.ability.ability == "spares.view" ||
                            el.ability.ability == "services.view"
                    });
                }
                if (ability == "Masters") {
                    permission = permissions.filter(function (el) {
                        return el.ability.ability == "equipment.view" ||
                            el.ability.ability == "asset_templates.view" ||
                            el.ability.ability == "assets.view"
                    });
                }
                if (ability == "Registers") {
                    permission = permissions.filter(function (el) {
                        return el.ability.ability == "activity_registers.view" ||
                            el.ability.ability == "service_registers.view" ||
                            el.ability.ability == "check_registers.view" ||
                            el.ability.ability == "inward_spare_register.view";
                    });
                }
                if (ability == "UserManagement") {
                    permission = permissions.filter(function (el) {
                        return el.ability.ability == "users.view" ||
                            el.ability.ability == "roles.view" ||
                            el.ability.ability == "permissions.view"
                    });
                }
                if (ability == "Reports") {
                    permission = permissions.filter(function (el) {
                        return el.ability.ability == "reports.view" ||
                            el.ability.ability == "job_pending_report" ||
                            el.ability.ability == "deviation_report" ||
                            el.ability.ability == "breakdown_report" ||
                            el.ability.ability == "asset_report" ||
                            el.ability.ability == "inventory_report" ||
                            el.ability.ability == "spare_ledger_report";
                    });
                }
                // if (ability == "Registers") {
                //     permission = permissions.filter(function (el) {
                //         return el.ability.ability == "userActivities.view" ||
                //         el.ability.ability == "userServices.view" ||
                //         el.ability.ability == "userChecks.view"

                //     });
                // }
                if (permission.length == 0) {
                    return false;
                } else {
                    return true;
                }
            }
            // return false;
        },
    },
};
</script>


<style scoped>
.sidebar-body .nav-sidebar {
    display: none;
    padding: 0 0 0px;
}

.sidebar-body .nav-label {
    font-size: 14px;
    text-transform: none;
    color: rgba(255, 255, 255, .6) !important;
}

.icn {
    margin-right: 8px;
    line-height: 1;
    font-size: 20px;
    width: 18px;
    opacity: .85;
}

.sidebar-body .nav-label.show1 {
    color: white !important;
}

.sidebar-body .nav-group.show .nav-label::after {
    content: "";
}

.sidebar {
    overflow-y: auto;
    scrollbar-color: #a9a9a9 transparent;
    scrollbar-width: none;
}
</style>